import { store } from '../Store/store';
import { ScrollActions } from '../actions/action';

function setHash(hash) {
  store.dispatch(ScrollActions.setHash(hash));
}

function reset() {
  store.dispatch(ScrollActions.reset());
}

function setParentPage(parentPage) {
  store.dispatch(ScrollActions.setParentPage(parentPage))
}

export default {
  setHash,
  reset,
  setParentPage
}


// WEBPACK FOOTER //
// ./src/services/HashService.js